exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#CatalogSearch .catalog-filter-status .chip {\n  width: 86px;\n  text-align: center; }\n\n#CatalogSearch.element-box {\n  padding: 1rem 1rem !important;\n  margin-bottom: .1rem; }\n\n#CatalogSearch .form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 2px solid #dde2ec;\n  border-radius: 4px; }\n\n#CatalogSearch .SelectCollapsible:last-child {\n  border-bottom: unset !important; }\n", ""]);

// exports
